module.exports = __webpack_public_path__ + "img/temperature-snow.65d74849.svg";